import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '@standardnotes/utils';
const MobileModalHeader = ({ className, children }) => {
    return (_jsx("div", { className: classNames('grid w-full select-none grid-cols-[0.35fr_1fr_0.35fr] gap-2 text-[1.05rem] leading-6', className), "data-mobile-modal-header": true, children: children }));
};
export default MobileModalHeader;
